import { Tree } from "../TreeFrames-min";
import { useImage } from "./hooks";

const TreeArray = () => {
  const [AA0, AA0S] = useImage(Tree[0]);
  const [AA1, AA1S] = useImage(Tree[1]);
  const [AA2, AA2S] = useImage(Tree[2]);
  const [AA3, AA3S] = useImage(Tree[3]);
  const [AA4, AA4S] = useImage(Tree[4]);
  const [AA5, AA5S] = useImage(Tree[5]);
  const [AA6, AA6S] = useImage(Tree[6]);
  const [AA7, AA7S] = useImage(Tree[7]);
  const [AA8, AA8S] = useImage(Tree[8]);
  const [AA9, AA9S] = useImage(Tree[9]);

  const [AA10, AA10S] = useImage(Tree[10]);
  const [AA11, AA11S] = useImage(Tree[11]);
  const [AA12, AA12S] = useImage(Tree[12]);
  const [AA13, AA13S] = useImage(Tree[13]);
  const [AA14, AA14S] = useImage(Tree[14]);
  const [AA15, AA15S] = useImage(Tree[15]);
  const [AA16, AA16S] = useImage(Tree[16]);
  const [AA17, AA17S] = useImage(Tree[17]);
  const [AA18, AA18S] = useImage(Tree[18]);
  const [AA19, AA19S] = useImage(Tree[19]);

  const [AA20, AA20S] = useImage(Tree[20]);
  const [AA21, AA21S] = useImage(Tree[21]);
  const [AA22, AA22S] = useImage(Tree[22]);
  const [AA23, AA23S] = useImage(Tree[23]);
  const [AA24, AA24S] = useImage(Tree[24]);
  const [AA25, AA25S] = useImage(Tree[25]);
  const [AA26, AA26S] = useImage(Tree[26]);
  const [AA27, AA27S] = useImage(Tree[27]);
  const [AA28, AA28S] = useImage(Tree[28]);
  const [AA29, AA29S] = useImage(Tree[29]);

  const [AA30, AA30S] = useImage(Tree[30]);
  const [AA31, AA31S] = useImage(Tree[31]);
  const [AA32, AA32S] = useImage(Tree[32]);
  const [AA33, AA33S] = useImage(Tree[33]);
  const [AA34, AA34S] = useImage(Tree[34]);
  const [AA35, AA35S] = useImage(Tree[35]);
  const [AA36, AA36S] = useImage(Tree[36]);
  const [AA37, AA37S] = useImage(Tree[37]);
  const [AA38, AA38S] = useImage(Tree[38]);
  const [AA39, AA39S] = useImage(Tree[39]);

  const [AA40, AA40S] = useImage(Tree[40]);
  const [AA41, AA41S] = useImage(Tree[41]);
  const [AA42, AA42S] = useImage(Tree[42]);
  const [AA43, AA43S] = useImage(Tree[43]);
  const [AA44, AA44S] = useImage(Tree[44]);
  const [AA45, AA45S] = useImage(Tree[45]);
  const [AA46, AA46S] = useImage(Tree[46]);
  const [AA47, AA47S] = useImage(Tree[47]);
  const [AA48, AA48S] = useImage(Tree[48]);
  const [AA49, AA49S] = useImage(Tree[49]);

  const [AA50, AA50S] = useImage(Tree[50]);
  const [AA51, AA51S] = useImage(Tree[51]);
  const [AA52, AA52S] = useImage(Tree[52]);
  const [AA53, AA53S] = useImage(Tree[53]);
  const [AA54, AA54S] = useImage(Tree[54]);
  const [AA55, AA55S] = useImage(Tree[55]);
  const [AA56, AA56S] = useImage(Tree[56]);
  const [AA57, AA57S] = useImage(Tree[57]);
  const [AA58, AA58S] = useImage(Tree[58]);
  const [AA59, AA59S] = useImage(Tree[59]);

  const [AA60, AA60S] = useImage(Tree[60]);
  const [AA61, AA61S] = useImage(Tree[61]);
  const [AA62, AA62S] = useImage(Tree[62]);
  const [AA63, AA63S] = useImage(Tree[63]);
  const [AA64, AA64S] = useImage(Tree[64]);
  const [AA65, AA65S] = useImage(Tree[65]);
  const [AA66, AA66S] = useImage(Tree[66]);
  const [AA67, AA67S] = useImage(Tree[67]);
  const [AA68, AA68S] = useImage(Tree[68]);
  const [AA69, AA69S] = useImage(Tree[69]);

  const newImages = Array.of(
    [AA0, AA0S],
    [AA1, AA1S],
    [AA2, AA2S],
    [AA3, AA3S],
    [AA4, AA4S],
    [AA5, AA5S],
    [AA6, AA6S],
    [AA7, AA7S],
    [AA8, AA8S],
    [AA9, AA9S],
    [AA10, AA10S],
    [AA11, AA11S],
    [AA12, AA12S],
    [AA13, AA13S],
    [AA14, AA14S],
    [AA15, AA15S],
    [AA16, AA16S],
    [AA17, AA17S],
    [AA18, AA18S],
    [AA19, AA19S],
    [AA20, AA20S],
    [AA21, AA21S],
    [AA22, AA22S],
    [AA23, AA23S],
    [AA24, AA24S],
    [AA25, AA25S],
    [AA26, AA26S],
    [AA27, AA27S],
    [AA28, AA28S],
    [AA29, AA29S],

    [AA30, AA30S],
    [AA31, AA31S],
    [AA32, AA32S],
    [AA33, AA33S],
    [AA34, AA34S],
    [AA35, AA35S],
    [AA36, AA36S],
    [AA37, AA37S],
    [AA38, AA38S],
    [AA39, AA39S],

    [AA40, AA40S],
    [AA41, AA41S],
    [AA42, AA42S],
    [AA43, AA43S],
    [AA44, AA44S],
    [AA45, AA45S],
    [AA46, AA46S],
    [AA47, AA47S],
    [AA48, AA48S],
    [AA49, AA49S],

    [AA50, AA50S],
    [AA51, AA51S],
    [AA52, AA52S],
    [AA53, AA53S],
    [AA54, AA54S],
    [AA55, AA55S],
    [AA56, AA56S],
    [AA57, AA57S],
    [AA58, AA58S],
    [AA59, AA59S],

    [AA60, AA60S],
    [AA61, AA61S],
    [AA62, AA62S],
    [AA63, AA63S],
    [AA64, AA64S],
    [AA65, AA65S],
    [AA66, AA66S],
    [AA67, AA67S],
    [AA68, AA68S],
    [AA69, AA69S]
  );
  return newImages;
};

export default TreeArray;
